'use client';

import { PayoutValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: PayoutValues;
  onValuesChange: (field: keyof PayoutValues, value: number | string) => void;
  translations: ToolsTranslations['payout'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof PayoutValues, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="dividend" className="block text-sm font-medium text-gray-700">{translations.dividendPerShare}</label>
        <div className="relative">
          <input id="dividend" type="text" value={values.dividendPerShare.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('dividendPerShare', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="eps" className="block text-sm font-medium text-gray-700">{translations.earningsPerShare}</label>
        <div className="relative">
          <input id="eps" type="text" value={values.earningsPerShare.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('earningsPerShare', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="cps" className="block text-sm font-medium text-gray-700">{translations.cashFlowPerShare}</label>
        <div className="relative">
          <input id="cps" type="text" value={values.cashFlowPerShare.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('cashFlowPerShare', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="fcfps" className="block text-sm font-medium text-gray-700">{translations.freeCashFlowPerShare}</label>
        <div className="relative">
          <input id="fcfps" type="text" value={values.freeCashFlowPerShare.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('freeCashFlowPerShare', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
    </div>
  );
}


